import React, { useState, useCallback } from 'react';
import ClinicSearch from '../ClinicSearch';

const Step1_SelectClinic = ({ onNext, error, setError }) => {
  const [clinicId, setClinicId] = useState('');

  const handleNext = useCallback(() => {
    if (!clinicId.trim()) {
      setError('Please select a clinic');
      return;
    }
    setError('');
    onNext({ clinicId: clinicId.trim() });
  }, [clinicId, onNext, setError]);

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Step 1: Select Clinic</h2>
        <p className="text-gray-600">
          Select the clinic (CLID) where you want to add doctor schedules.
        </p>
      </div>

      <ClinicSearch
        selectedClinicId={clinicId}
        onClinicSelect={setClinicId}
        error={error}
        setError={setError}
      />

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-800">{error}</div>
      )}

      <div className="flex justify-end">
        <button
          onClick={handleNext}
          disabled={!clinicId.trim()}
          className="px-8 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed font-medium"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Step1_SelectClinic;
